export interface EducationEntry {
  institution: string
  credential: string
  years?: string
  detail?: string[]
}

export const education: EducationEntry[] = [
  {
    institution: 'Purdue University',
    credential: 'Bachelor of Science — BS, Computer Science',
    years: '1984 – 1988',
    detail: [
      'Co-operative education program with IBM for four semesters.',
      'Marching band and orchestra; Kappa Kappa Psi.',
      'Studied computer science and mathematics.',
    ],
  },
  {
    institution: 'Pragmatic Institute',
    credential: 'Pragmatic Marketing Certified',
  },
  {
    institution: 'Agile Inc',
    credential: 'Agile Frameworks · Certified Scrum Product Owner',
  },
]

export const domainFocus: string[] = [
  'Enterprise SaaS',
  'Big Data Integration',
  'AI / ML Analytics',
  'Data Lakes',
  'EdTech',
  'Cloud Platforms (AWS)',
  'Master Data Management',
  'Business Intelligence',
]
